import { useCallback, useEffect, useState } from "react";
import '../../../Airoom.css';
import Table from "../../../core/common/dataTable/index";
import ModalComponent from "../../../core/common/modal/ModalComponent";
import { TableData } from "../../../core/data/interface";
import { useGetAllRolesQuery } from "../../../services/EndPointsApis";
import { svgIcons } from "../../../style/fonts/SvgIcons";
import { useTableSelection } from "../../../core/hooks/useTableSelection";
import NoRecordFound from "../../../core/common/noRecord/NoRecordFound";
import TextField from "../../../core/common/textFields/TextField";
import TableLoading from "../../../core/common/loadingComponent/TableLoading";
import Pagination from "../../../core/common/pagination/Pagination";
import Ribbon, { ToggleButton } from "../../../core/common/ribbon/ribbon";
import ActiveUserModal from "./ActiveUserModal";
import PermissionsComponent from "../Permissions/PermissionsComponent";
import { debounce } from "lodash";

// import PermissionIcon from "../../style/fonts/SvgIcons";



const Roles = () => {
  const [showModal, setShowModal] = useState(false);
  const [adduser, setAdduser] = useState(false);
  const [modalTitle, setModalTitle] = useState("Add New Role");
  const [buttonTitle, setButtonTitle] = useState("Save");
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(15);
  const [searchStr, setSearchStr] = useState('');
  const [sortBy, setSortBy] = useState("createDT");
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortedColumn, setSortedColumn] = useState("createDT");
  const [immediateSearchStr, setImmediateSearchStr] = useState('')

  const { data: allRoles, refetch, isLoading } = useGetAllRolesQuery({
    pageNumber: pageNumber,
    pageSize: pageSize,
    searchStr: searchStr || '',
    sortBy: sortBy,
    sortOrder: sortOrder,
  });


  const rolesPermissionsData = allRoles?.result?.data?.map((tableData: any, key: any) => ({
    key: tableData.id,
    roleName: tableData.name,
  })) || [];

  const dataSource = rolesPermissionsData;
  const {
    isTableHeadChecked,
    selectedIndividualCheckboxId,
    selectedItemData: RoleData,
    handleTableHeadChange,
    handleCheckItem,
    handleRowClick,
    handleDelete
  } = useTableSelection(allRoles?.result?.data || [], 'id');

  const togglePopup = (isEditing: any) => {
    setAdduser(!adduser);
    setModalTitle(isEditing ? "Update Role" : "Add New Role");
    setButtonTitle(isEditing ? "Update" : "Save");
    setShowModal(true);
  };
  const [currentToggleState, setCurrentToggleState] = useState(false);
  const [showActiveUserModal, setShowActiveUserModal] = useState(false)

  const isAnyCheckboxChecked = selectedIndividualCheckboxId.length > 0;
  const isMoreThanOneChecked = selectedIndividualCheckboxId.length > 1;

  const handleToggle = () => {
    const newToggleState = !currentToggleState;
    setCurrentToggleState(newToggleState);
    setShowActiveUserModal(true);
  }
  const handleCloseStatusModal = () => {
    setShowActiveUserModal(false)
    setCurrentToggleState(!currentToggleState)
  };
  const handleRowClicked = (data: any) => {
    handleRowClick(data);
    // setIsRowClicked(true);
    if (data?.active === true) {
      setCurrentToggleState(true)
    } else {
      setCurrentToggleState(false)
    }
  }

  const items = [
    {
      label: "Active",
      onClick: () => {
        setShowActiveUserModal(true);
      },
      ToggleButton: <ToggleButton
        onChange={handleToggle}
        id="toggle"
        checked={currentToggleState}
        disableButton={!isAnyCheckboxChecked || isMoreThanOneChecked}
      />
    },
  ];

  //table sorting
  const handleSort = (property: string) => {
    setSortBy(property);
    if (sortedColumn === property) {
      setSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortedColumn(property);
      setSortOrder("asc");
    }
  };

  const handlePageSizeChange = (selectedOption: any) => {
    setPageSize(selectedOption.value);
    setPageNumber(1);
  };

  // pagination
  const handlePageClick = (e: any) => {
    setPageNumber(e.selected + 1);
  };

  // Search

  const handleSearchChange = (e: any) => {
    const { value } = e.target;
    setImmediateSearchStr(value);
    delayedSearch(value);
  };

  const delayedSearch = useCallback(
    debounce((searchValue) => {
      setSearchStr(searchValue);
    }, 500),
    []
  );
  useEffect(() => {
    if (searchStr === "" ||
      sortOrder === "" ||
      sortBy === "") {
      refetch();
    }
  }, [searchStr, sortOrder, sortBy]);





  return (
    <>
      <ActiveUserModal
        show={showActiveUserModal}
        handleClose={handleCloseStatusModal}
        data={RoleData}
        refetch={refetch}
        setCurrentToggleState={setCurrentToggleState}
        handleDelete={handleDelete}
      />
      <div>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                <Ribbon
                  items={items}
                // toggleData="modal"
                // onClick={() => togglePopup(false)}
                />
                {/* /Page Header */}
                <div className="card">
                  <div className="card-body">
                    {/* Search */}
                    <div className="d-flex justify-content-between mb-2">
                      <div className="">
                        <h4 className="page-title color-red">
                          Roles
                        </h4>
                      </div>
                      <div className="">
                        <div className="icon-form">
                          <span className="form-icon">
                            <i className="ti ti-search" />
                          </span>
                          <input
                            type="text"
                            className="form-control min-height"
                            placeholder="Search Roles"
                            onChange={handleSearchChange}
                          />
                        </div>
                      </div>
                      {/* <div className="col-md-6 d-flex justify-content-end">
                          <div className="form-wrap icon-form">
                            <span className="form-icon">
                              <i className="ti ti-search" />
                            </span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search Roles"
                            />
                          </div>
                        </div> */}
                    </div>
                    {/* /Search */}
                    {/* Roles List */}
                    <div className="table-responsive custom-table">
                    <table className="table datanew dataTable no-footer table-hover">
                        <thead>
                          <tr>
                            <th>
                              {/* <input
                              type="checkbox"
                              className='form-check-input cursor-pointer'
                              checked={isTableHeadChecked}
                              onChange={handleTableHeadChange}
                            /> */}
                            </th>
                            <th>Sr No</th>
                            <th>NAME</th>
                            <th>STATUS</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading && selectedIndividualCheckboxId.length > 0 ? (<tr>
                            <td colSpan={7}>
                              <NoRecordFound />
                            </td>
                          </tr>) : (
                            <>
                              {allRoles?.result?.data?.map((data: any, index: any) => {
                                  const rowNumber = (pageNumber - 1) * pageSize + index + 1;

                                return (
                                  <tr key={index} onClick={() => handleRowClicked(data)}
                                    className={selectedIndividualCheckboxId.includes(data.id) ? 'selected-row' : ''}>
                                    <td>
                                      <TextField
                                        type="checkbox"
                                        fieldClass='form-check-input cursor-pointer'
                                        checked={isTableHeadChecked || selectedIndividualCheckboxId.includes(data.id)}
                                        onChange={(e: any) => handleCheckItem(e, data)}
                                      />
                                    </td>
                                    {/* <td>{data?.id}</td> */}
                                    <td>{rowNumber}</td>
                                    <td>{data?.name}</td>
                                    <td>
                                      {data?.active === true ? (
                                        <span className="badge badge-pill badge-status bg-soft-success text-success">Active</span>
                                      ) : (
                                        <span className="badge badge-pill badge-status bg-soft-danger text-danger">Inactive</span>
                                      )}
                                    </td>
                                  </tr>
                                )
                              })}
                            </>
                          )}
                          {isLoading &&
                            <TableLoading />
                          }
                        </tbody>
                      </table>
                    </div>
                    {/* <Pagination/> */}
                    <Pagination
                      onChange={handlePageSizeChange}
                      pageSize={pageSize}
                      onPageChange={handlePageClick}
                      pageCount={allRoles?.result?.totalPages || 0}
                    />
                    {/* /Roles List */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Roles;
